export const typeFilters = [
  {
    'id': 0,
    'handle': 'b',
    'title': 'Billing',
    'icon': 'star'
  },
  {
    'id': 1,
    'handle': 't',
    'title': 'Time-sheet',
    'icon': 'exclamation'
  },
  {
    'id': 2,
    'handle': 'r',
    'title': 'Recruiter',
    'icon': 'crm'
  },
  {
    'id': 3,
    'handle': 'o',
    'title': 'Other',
    'icon': 'chart-composed'
  }
];

export const clientTypeFilters = [
  {
    'id': 0,
    'handle': 'v',
    'title': 'Vendor',
    'icon': 'star'
  },
  {
    'id': 1,
    'handle': 'i',
    'title': 'I/P',
    'icon': 'exclamation'
  },
  {
    'id': 2,
    'handle': 'c',
    'title': 'Client',
    'icon': 'crm'
  }
];

export const statusFilters = [
  {
    'id': 0,
    'handle': 'n',
    'title': 'New',
    'icon': 'star'
  },
  {
    'id': 1,
    'handle': 'o',
    'title': 'On-bench',
    'icon': 'exclamation'
  },
  {
    'id': 2,
    'handle': 'm',
    'title': 'Marketing',
    'icon': 'crm'
  },
  {
    'id': 4,
    'handle': 'p',
    'title': 'On-project',
    'icon': 'chart-composed'
  },
  {
    'id': 3,
    'handle': 't',
    'title': 'In training',
    'icon': 'data-display'
  },
];

export const marketerStatusFilters = [
  {
    'id': 1,
    'handle': 'm',
    'title': 'Marketing',
    'icon': 'crm'
  },
  {
    'id': 2,
    'handle': 'p',
    'title': 'On-project',
    'icon': 'chart-composed'
  }
];

export const rtgFilters = [
  {
    'id': 0,
    'handle': 'True',
    'title': 'Yes',
    'icon': 'check-circle-o'
  },
  {
    'id': 1,
    'handle': 'False',
    'title': 'No',
    'icon': 'close-circle'
  }];


export const subStatusFilters = [
  {
    'id': 0,
    'handle': 'new',
    'title': 'New',
    'icon': 'star'
  },
  {
    'id': 1,
    'handle': 'sub',
    'title': 'Submitted',
    'icon': 'exclamation'
  },
  {
    'id': 3,
    'handle': 'int1,int2,fin_int',
    'title': 'Interview',
    'icon': 'crm'
  },
  {
    'id': 4,
    'handle': 'offer',
    'title': 'Offer',
    'icon': 'chart-composed'
  },
  {
    'id': 2,
    'handle': 'scr,scr_2',
    'title': 'Screening',
    'icon': 'data-display'
  },
];

  export const submissionStatusFilters = [
    {
      'id': 0,
      'handle': 'p',
      'title': 'Pending',
      'icon': 'star'
    },
    {
      'id': 1,
      'handle': 'c',
      'title': 'Completed',
      'icon': 'exclamation'
    },
    {
      'id': 3,
      'handle': 'f',
      'title': 'Failed',
      'icon': 'crm'
    },

  ]

  export const offersStatusFilters = [
    {
      'id': 0,
      'handle': 'all',
      'title': 'All',
      'icon': 'star',
      'color': '#1677ff'
    },
    // {
    //   'id': 1,
    //   'handle': 'p',
    //   'title': 'Pending',
    //   'icon': 'star',
    //   'color': '#1677ff'
    // },
    {
      'id': 5,
      'handle': 'j',
      'title': 'Joining Pending',
      'icon': 'crm',
      'color': '#1677ff'
    },
    {
      'id': 3,
      'handle': 'o',
      'title': 'Ongoing',
      'icon': 'crm',
      'color': '#52c41a'
    },
    {
      'id': 2,
      'handle': 'c',
      'title': 'Completed',
      'icon': 'exclamation',
      'color': '#52c41a'
    },
    {
      'id': 4,
      'handle': 't',
      'title': 'Terminated',
      'icon': 'crm',
      'color': '#ff4d4f'
    },
    {
      'id': 6,
      'handle': 'n',
      'title': 'Never Started',
      'icon': 'crm',
      'color': '#ff4d4f'
    },
  ]

  export const ProjectTypeFilters = [
    {
      'id': 0,
      'handle': 'all',
      'title': 'All',
    },
    {
      'id': 1,
      'handle': 'inhouse',
      'title': 'In-House',
    },
    {
      'id': 2,
      'handle': 'outsource',
      'title': 'Outsource',
    },
    {
      'id': 3,
      'handle': 'regular',
      'title': 'Regular',
    },
]
  export const TaxTermOptionFilters = [
    {
      'id': 0,
      'handle': 'all',
      'title': 'All',
    },
    {
      'id': 1,
      'handle': 'w2',
      'title': 'W2',
    },
    {
      'id': 2,
      'handle': '1099',
      'title': '1099',
    },
    {
      'id': 3,
      'handle': 'c2c',
      'title': 'c2c',
    },
  ]

  export const PayrollTaxTermOptions = [
    {
      'id': 0,
      'handle': 'all',
      'title': 'All',
    },
    {
      'id': 1,
      'handle': 'w2',
      'title': 'W2',
    },
    {
      'id': 2,
      'handle': '1099-b',
      'title': '1099-B',
    },
    {
      'id': 3,
      'handle': '1099-i',
      'title': '1099-I',
    },
  ]

  export const PaginationPageLength = [
    {
      'id': 1,
      'title': "20 / List",
      'handle': 20,
    },
    {
      'id': 2,
      'title': "50 / List",
      'handle': 50,
    },
    {
      'id': 3,
      'title': "100 / List",
      'handle': 100,
    },
  ]

  export const PaymentFrequency = [
    {
      'id': 1,
      'title': "Weekly",
      'handle': 'weekly',
    },
    {
      'id': 2,
      'title': "Bi-Weekly",
      'handle': 'bi_weekly',
    },
    {
      'id': 3,
      'title': "Semi-Monthly",
      'handle': 'semi_monthly',
    },
    {
      'id': 4,
      'title': "Monthly",
      'handle': 'monthly',
    },
  ]
  export const CurrencyChoices = [
    {
      'id': 1,
      'title': "INR",
      'handle': 'inr',
    },
    {
      'id': 2,
      'title': "USD",
      'handle': 'usd',
    }
  ]
  export const SupplySourceChoices = [
    {
      'id': 1,
      'title': "Direct",
      'handle': 'direct',
    },
    {
      'id': 2,
      'title': "Supplier",
      'handle': 'supplier',
    }
  ]

  export const WeekDaysChoices = [
    {
      'id': 2,
      'title': "Monday",
      'handle': 0,
    },
    {
      'id': 3,
      'title': "Tuesday",
      'handle': 1,
    },
    {
      'id': 4,
      'title': "Wednesday",
      'handle': 2,
    },
    {
      'id': 5,
      'title': "Thursday",
      'handle': 3,
    },
    {
      'id': 6,
      'title': "Friday",
      'handle': 4,
    },
    {
      'id': 7,
      'title': "Saturday",
      'handle': 5,
    },
    {
      'id': 8,
      'title': "Sunday",
      'handle': 6,
    },
  ]

  export const timeZoneOptions = [
    { value: "America/New_York", label: "EST" },
    { value: "America/Chicago", label: "CST" },
    { value: "America/Denver", label: "MST" },
    { value: "America/Los_Angeles", label: "PST" },
    { value: "Asia/Kolkata", label: "IST" },
  ];


  export const bgcOfferDocumentTypeOption = [
    {   
      'id': 1,
      'title': "Degree",
      'value': "degree",
    },
    {   
      'id': 2,
      'title': "Mark-sheet",
      'value': "mark_sheet",
    },
    {   
      'id': 3,
      'title': "Educational Document",
      'value': "educational_document",
    },
    {   
      'id': 4,
      'title': "Driver License",
      'value': "driver_license",
    },
    {   
      'id': 5,
      'title': "Passport",
      'value': "passport",
    },
    {   
      'id': 6,
      'title': "Offer Letter",
      'value': "offer_letter",
    },
    {   
      'id': 7,
      'title': "Release Letter",
      'value': "release_letter",
    },
    {   
      'id': 8,
      'title': "Pay Stub",
      'value': "pay_stub",
    },
    {   
      'id': 9,
      'title': "Consultant E-Verify",
      'value': "consultant_e_verify",
    },
    {   
      'id': 10,
      'title': "Drug Test Pass",
      'value': "drug_test_pass",
    },
    {   
      'id': 11,
      'title': "Fingerprint Pass",
      'value': "fingerprint_pass",
    },
    {   
      'id': 12,
      'title': "BGC SS",
      'value': "bgc_ss",
    },
    {   
      'id': 13,
      'title': "NDA",
      'value': "nda",
    },
    {   
      'id': 14,
      'title': "Employment Details",
      'value': "employment_details",
    },
    {   
      'id': 15,
      'title': "Other",
      'value': "other",
    },
  ]

  export const paperWorkOfferDocumentTypeOption = [
    {   
      'id': 1,
      'title': "Purchase Order",
      'value': "purchase_order",
    },
    {   
      'id': 2,
      'title': "Master Service Agreement",
      'value': "master_service_agreement",
    },
    {   
      'id': 3,
      'title': "Company E-Verify",
      'value': "company_e_verify",
    },
    {   
      'id': 4,
      'title': "W-9",
      'value': "w9",
    },
    {   
      'id': 5,
      'title': "COI",
      'value': "coi",
    },
    {   
      'id': 6,
      'title': "Direct Deposit Form/ Payment Details",
      'value': "direct_deposit_form",
    },
    {   
      'id': 7,
      'title': "I-9",
      'value': "i9",
    },
    {   
      'id': 8,
      'title': "Appendix",
      'value': "appendix",
    },
    {   
      'id': 9,
      'title': "W2 - Offer Letter",
      'value': "w2_offer_letter",
    },
    {   
      'id': 10,
      'title': "Other",
      'value': "other",
    },
  ]

  export const accountTypesOption = [
    {   
      'id': 1,
      'title': "Current",
      'value': "current",
    },
    {   
      'id': 2,
      'title': "Saving",
      'value': "saving",
    },
  ]

  export const active_Inactive_Option = [
    {   
      'id': 1,
      'title': "Active",
      'value': "active",
    },
    {   
      'id': 2,
      'title': "In-Active",
      'value': "inactive",
    },
  ]

  export const currencyOption = [
    {   
      'id': 1,
      'title': "USD",
      'value': "USD",
    },
    {   
      'id': 2,
      'title': "INR",
      'value': "INR",
    },
  ]

  export const AccountReceivableStatusFilters = [
    {
      'id': 0,
      'handle': 'pending',
      'title': 'Pending',
    },
    {
      'id': 1,
      'handle': 'approved',
      'title': 'Approved',
    },
    {
      'id': 3,
      'handle': 'rejected',
      'title': 'Rejected',
      'icon': 'crm'
    },

  ]

  export const AccountPayableType = [
    {
      'id': 0,
      'handle': 'consultant',
      'title': 'Consultant',
    },
    {
      'id': 1,
      'handle': 'support',
      'title': 'Support',
    },
    {
      'id': 2,
      'handle': 'device_handling_rate',
      'title': 'Device Handling Rate',
    },
    {
      'id': 3,
      'handle': 'payroll_cost',
      'title': 'Payroll Cost',
    },
    {
      'id': 4,
      'handle': 'other',
      'title': 'Other',
    },
  ]

  export const transactionType = [
    {
      'id': 0,
      'handle': 'debit',
      'title': 'Debit',
    },
    {
      'id': 1,
      'handle': 'credit',
      'title': 'Credit',
    },
  ]

  export const relationOption = [
    {
      'id': 0,
      'handle': 'self',
      'title': 'Self',
    },
    {
      'id': 1,
      'handle': 'mother',
      'title': 'Mother',
    },
    {
      'id': 2,
      'handle': 'father',
      'title': 'Father',
    },{
      'id': 3,
      'handle': 'spouse',
      'title': 'Spouse',
    },
    {
      'id': 4,
      'handle': 'brother',
      'title': 'Brother',
    },
    {
      'id': 5,
      'handle': 'sister',
      'title': 'Sister',
    },
    {
      'id': 6,
      'handle': 'child',
      'title': 'Child',
    },
    {
      'id': 7,
      'handle': 'friend',
      'title': 'Friend',
    },
    {
      'id': 8,
      'handle': 'other',
      'title': 'Other',
    }
  ]

  export const fieldTypes = [
    { label: "Text", value: "text" },
    { label: "Number", value: "number" },
    { label: "Email", value: "email" },
    { label: "Radio Options", value: "radio" },
    { label: "Multiple Options", value: "checkbox" },
    { label: "File", value: "file" },
];
  export const isPaidOption = [
    {
      'id': 0,
      'handle': 'true',
      'title': 'Paid',
    },
    {
      'id': 1,
      'handle': 'false',
      'title': 'Not Paid',
    },
  ]

  export const payStatusOption = [
    {
      id: 0,
      handle: 'paid',
      title: 'Paid',
    },
    {
      id: 1,
      handle: 'not paid',
      title: 'Not Paid',
    },
    {
      id: 2,
      handle: 'overpaid',
      title: 'Overpaid',
    },
    {
      id: 3,
      handle: 'paid extra',
      title: 'Paid Extra',
    },
  ];

  export const paymentTypeOption = [
    {
      id: 0,
      handle: '1099',
      title: '1099',
    },
    {
      id: 1,
      handle: 'w2',
      title: 'W2',
    },
    {
      id: 2,
      handle: 'ic',
      title: 'IC',
    },
    {
      id: 3,
      handle: 'other adjustment',
      title: 'Other Adjustment',
    },
  ];

  export const extraAmountType = [
    {
      id: 0,
      handle: 'receivable',
      title: 'Receivable',
    },
    {
      id: 1,
      handle: 'payable',
      title: 'Payable',
    },
  ];

  export const holdAmountType = [
    {
      id: 0,
      handle: 'received',
      title: 'Received',
    },
    {
      id: 1,
      handle: 'paid',
      title: 'Paid',
    },
  ];

  export const payeeTypeOption = [
  {
    id: 0,
    handle: 'consultant',
    title: 'Consultant',
  },
  {
    id: 1,
    handle: 'device_handling_rate',
    title: 'Device Handling Rate',
  },
  {
    id: 2,
    handle: 'inhouse_engineer_rate',
    title: 'In-house Engineer Rate',
  },
  {
    id: 3,
    handle: 'payroll_cost',
    title: 'Payroll Cost',
  },
  {
    id: 4,
    handle: 'other',
    title: 'Other',
  },
];

  export const timehseetAttchmentType_Option = [
    {   
      'id': 1,
      'title': "Client",
      'handle': "client",
    },
    {   
      'id': 2,
      'title': "Vendor",
      'handle': "vendor",
    },
    {   
      'id': 3,
      'title': "Pay Stub",
      'handle': "pay_stub",
    },
  ]

